import { defineStore } from 'pinia'

export const useProcessoParadigmaStore = defineStore('processoparadigma', {
  state: () => ({
    processos: [],

    classe: 0,
    numero: 0,
    numeroProcessoSTJ: "",
    situacaoSTJ: "",
    numeroProcessoSTF: "",
    situacaoSTF: "",
    dataJulgamento: "",
    dataTransito: "",
    relator: "",
    orgaoJulgador: "",
    linkProcesso: "",
    dataAcordao: "",
    idTema: "",
    idGrupoRepresentativo: 0,
    in_ativo: false
  }),
  getters: {
    all: state => state.processos,
  },
  actions: {
    save() {
      this.processos.push({
        classe: this.classe,
        numero: this.numero,
        numeroProcessoSTJ: this.numeroProcessoSTJ,
        situacaoSTJ: this.situacaoSTJ,
        numeroProcessoSTF: this.numeroProcessoSTF,
        situacaoSTF: this.situacaoSTF,
        dataJulgamento: this.dataJulgamento,
        dataTransito: this.dataTransito,
        relator: this.relator,
        orgaoJulgador: this.orgaoJulgador,
        linkProcesso: this.linkProcesso,
        dataAcordao: this.dataAcordao,
        idTema: this.idTema,
        idGrupoRepresentativo: this.idGrupoRepresentativo,
        in_ativo: this.in_ativo,
      })
      this.clear()
    },
    clear() {
      this.classe = 0
      this.numero = 0
      this.numeroProcessoSTJ = ""
      this.situacaoSTJ = ""
      this.numeroProcessoSTF = ""
      this.situacaoSTF = ""
      this.dataJulgamento = ""
      this.dataTransito = ""
      this.relator = ""
      this.orgaoJulgador = ""
      this.linkProcesso = ""
      this.dataAcordao = ""
      this.idTema = ""
      this.idGrupoRepresentativo = ""
      this.in_ativo = ""
    }
  },
})
